module.exports = __webpack_public_path__ + "media/svg-new/icon-prob-desempenho-513e4aca.svg";